import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useForumStreamsQuery = getWrappedUseQuery(KEYS.GET_STREAMS, apiClient.ForumStreams.getAll);

export const useForumStreamsAndSeminarsAndSessionsQuery = getWrappedUseQuery(
  KEYS.GET_FORUM_STREAMS_AND_SEMINARS_AND_SESSIONS,
  apiClient.ForumStreams.getStreamsAndSeminarsAndSessions,
);
